import React, { useMemo } from "react";
import { Button, Modal, Row, Typography, Col, Input, InputNumber } from "antd";
import { AreaProps } from "src/entity/area/area.entity";
import { ResponseSettingWasteWaterTreatment } from "src/entity/settings/waste-water";
import { ObjectEmissionWithValue, ResponseManualWasteWater } from "src/entity/waste-water/manual-waste-water.entity";
import CustomInputNumber from "src/components/AntdCustomPart/InputNumber/CustomInputNumber";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { MONTHS_LISTS } from "src/entity/common/time.constant";
import { TmpReportEmissionData } from "src/entity/waste-water/report-voc-emission.entity";
import { ReportStatusEnum } from "src/entity/voc-approve/voc-approve.entity";
import { formatNumber } from "src/utils/process-number";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { convertEmissionWord } from "src/entity/common/global.entity";

const { Text } = Typography;

interface ManualVocWaterModalProps {
  submitSetupHeatingValue: () => void;
  loadingManageWasteWater: boolean;
  visibleModal: boolean;
  closeModal: () => void;
  errorWasteWater: string | null;
  isEdit: ResponseManualWasteWater | null;
  getMasterLabel: (type: string, text: string) => string | undefined;
  onUpdateKeyValue: (key: keyof ObjectEmissionWithValue, value: string | number) => void;
}

const ManualVocWaterModal: React.FC<ManualVocWaterModalProps> = (props) => {
  const {
    submitSetupHeatingValue,
    loadingManageWasteWater,
    closeModal,
    visibleModal,
    errorWasteWater,
    isEdit,
    getMasterLabel,
    onUpdateKeyValue,
  } = props;

  // console.log("[Manual] IS EIDT :: ", isEdit);

  const activeEmissionLists = useMemo(() => {
    const lists: any = [];
    if (!isEdit?.cloneEmission) return lists;
    lists.push("header_column");
    for (const key in isEdit?.cloneEmission) {
      if (isEdit.cloneEmission[key as keyof ObjectEmissionWithValue].active) lists.push(key);
    }
    return lists;
  }, [isEdit]);

  const isSomeProcessing = useMemo(() => {
    if (!isEdit) return true;

    let someMonthProcessing = false;
    const months = MONTHS_LISTS;
    const activeEmissions: string[] = activeEmissionLists.filter((item: string) => item != "header_column");

    for (const key in isEdit?.vocEmission) {
      if (activeEmissions.includes(key)) {
        for (const month of months) {
          if (
            isEdit.vocEmission[key as keyof ObjectEmissionWithValue][month as keyof TmpReportEmissionData].reportStatus ===
            ReportStatusEnum.PROCESSING
          ) {
            someMonthProcessing = true;
            break;
          }
        }
        break;
      }
    }
    return someMonthProcessing;
  }, [isEdit]);

  // console.log("activeEmissionLists :: ", activeEmissionLists);

  return (
    <Modal
      title={<ModalTitle title="VOC Water 9" />}
      open={visibleModal}
      width={1000}
      onCancel={closeModal}
      footer={
        <Row className="w-full border-t" justify={"end"}>
          <Button className="mt-4" key="submit" type="primary" loading={loadingManageWasteWater} onClick={submitSetupHeatingValue}>
            Save
          </Button>
        </Row>
      }
      maskClosable={false}
      centered
    >
      {errorWasteWater && (
        <Row className="w-full" justify={"center"}>
          <Text type="danger">{errorWasteWater}</Text>
        </Row>
      )}
      <Row className="w-full mt-4" gutter={[12, 0]}>
        <Col xs={12} sm={6} md={6}>
          <Text>Wastewater Unit</Text>
          <Input className="mt-2" disabled value={isEdit?.wasteWaterUnit} />
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Text>Area</Text>
          <Input className="mt-2" disabled value={getMasterLabel("area", isEdit?.area as string)} />
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Text>Emission Control</Text>
          <Input className="mt-2" disabled value={isEdit?.emissionControl?.emissionControl} />
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Text>Efficiency (%)</Text>
          <Input className="mt-2" disabled value={isEdit?.efficiency} />
        </Col>
      </Row>

      {activeEmissionLists.map((emissionKey: string, index: number) => {
        if (emissionKey === "header_column")
          return (
            <Row className="w-full mt-4" justify={"center"} key={index + "header"}>
              <Col span={2}>{""}</Col>
              <Col span={2}>Unit</Col>
              <Col span={7}>Emission Before Treatment per Year</Col>
            </Row>
          );
        else
          return (
            <Row className="w-full mt-4" justify={"center"} align={"middle"} key={index + "content"}>
              <Col span={2}>{convertEmissionWord(emissionKey.toUpperCase())}</Col>
              <Col span={2}>Mg</Col>
              <Col span={7}>
                <InputNumber
                  value={isEdit?.cloneEmission[emissionKey as keyof ObjectEmissionWithValue].emissionBeforeTreatment}
                  onChange={(val) => onUpdateKeyValue(emissionKey as keyof ObjectEmissionWithValue, val?.toString() as string | number)}
                  disabled={!isSomeProcessing}
                  min={0}
                  step={1}
                  onKeyDown={(e) => {
                    onKeyDownNumberWithFixedDecimal(e, 10);
                  }}
                  formatter={(value) => formatNumber(value as number, 10)}
                  style={{ width: "75%" }}
                />
              </Col>
            </Row>
          );
      })}
    </Modal>
  );
};

export default ManualVocWaterModal;
// 9999.22
